import { redirect } from 'shared/helpers/redirect';

export const handleToRentLandingRouting = (url: string) => {
    const isToRentLanding = url === '/to-rent/';

    if (isToRentLanding) {
        redirect(url);
    }
};
